import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { throwError, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { MediaSummary } from '../models';
import { EnvironmentService } from './environment.service';
import { RemoteConfigService } from './remote-config.service';

const DEFAULT_SEARCH_VERSION = '10';

@Injectable({
  providedIn: 'root'
})
export class SearchService {

  constructor(
    private envService: EnvironmentService,
    private config: RemoteConfigService,
    private http: HttpClient) { }

  /** Search API version from remote config (search_version), mirroring the web app. */
  private get apiVersion(): string {
    return 'v' + (this.config.remoteConfig?.search_version || DEFAULT_SEARCH_VERSION);
  }

  search(search, creatorId): Observable<MediaSummary[]> {
    if (creatorId) {
      return this.http.get<MediaSummary[]>(this.envService.contentHost + '/' + this.apiVersion + '/search?s=' + search + '&ctid=' + creatorId).pipe(catchError(error => {
        if (!environment.production)
          console.error('SearchService::Error::GET', error);
        return throwError(error);
      }))
    } else {
      return this.http.get<MediaSummary[]>(this.envService.contentHost + '/' + this.apiVersion + '/search?s=' + search).pipe(catchError(error => {
        if (!environment.production)
          console.error('SearchService::Error::GET', error);
        return throwError(error);
      }))
    }
  }
}
